import React from 'react'
import { get } from 'lodash';
import PropTypes from 'prop-types';

function CalculationItemRanges({ data }) {
  
  return (
    <>
      {data.length > 0 && ['bpls_tax_revenue_calculation_ranges'].indexOf(get(data, '0.type')) > -1 && (
        <div className="px-1">
          <table className="table table-bordered table-stripped table-sm">
            <thead>
              <tr>
                <th width="150" className="text-right">FROM</th>
                <th width="150" className="text-right">TO</th>
                {get(data, '0.attributes.for_every_human') && (
                  <th width="150" className="text-right">FOR EVERY</th>  
                )}
                {get(data, '0.attributes.for_every_amount_human') && (
                  <th width="150" className="text-right">FOR EVERY AMOUNT</th>  
                )}
                {get(data, '0.attributes.rate_human') && (
                  <th width="150" className="text-right">RATE</th>  
                )}
                <th width="150" className="text-right">AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {data.map(detail => {
                return (
                  <tr>
                    <td className="text-dark text-right" width="150">
                      {get(detail, 'attributes.from_human') || '-'}
                    </td>
                    <td className="text-dark text-right" width="150">
                      {get(detail, 'attributes.to_human') || '-'}
                    </td>
                    {get(detail, 'attributes.for_every_human') && (
                      <td className="text-dark text-right" width="150">
                        {get(detail, 'attributes.for_every_human') || '-'}
                      </td>
                    )}
                    {get(detail, 'attributes.for_every_amount_human') && (
                      <td className="text-dark text-right" width="150">
                        {get(detail, 'attributes.for_every_amount_human') || '-'}
                      </td>
                    )}
                    {get(detail, 'attributes.rate_human') && (
                      <td className="text-dark text-right" width="150">
                        {`${get(detail, 'attributes.rate_human')}` || '-'}
                      </td>
                    )}
                    <td colSpan={4} width="150" className="text-right">
                      <b>
                        {get(detail, 'attributes.amount_human') || '-'}
                      </b>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}


CalculationItemRanges.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired
}

export default CalculationItemRanges
